@for (flashMessage of flashMessages; track flashMessage) {
  <div flashMessage
    [flashMessageItem]="flashMessage">
  </div>
}
